var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertKeySkill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_5874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6139 24.8527C42.8369 24.8248 43.0418 24.7161 43.1898 24.5471C43.3378 24.3781 43.4187 24.1606 43.4169 23.936V20.0603C43.4187 19.8357 43.3378 19.6182 43.1898 19.4492C43.0418 19.2802 42.8369 19.1715 42.6139 19.1437L38.4871 18.6285C38.0664 16.6072 37.2671 14.6838 36.1313 12.9598L38.6888 9.65982C38.8257 9.48356 38.8936 9.26339 38.8798 9.04062C38.8659 8.81785 38.7713 8.60778 38.6136 8.44982L35.8636 5.69982C35.7056 5.54212 35.4956 5.44748 35.2728 5.43364C35.05 5.4198 34.8299 5.48772 34.6536 5.62465L31.3683 8.20415C29.6439 7.06849 27.7207 6.2686 25.6996 5.84648L25.1844 1.72148C25.1566 1.49856 25.0478 1.29363 24.8789 1.1456C24.7099 0.997573 24.4924 0.916751 24.2678 0.918484H20.3921C20.1675 0.916751 19.95 0.997573 19.781 1.1456C19.612 1.29363 19.5033 1.49856 19.4754 1.72148L18.9603 5.84648C16.9417 6.26947 15.021 7.06934 13.2989 8.20415L10.0081 5.64665C9.83184 5.50972 9.61167 5.4418 9.3889 5.45564C9.16613 5.46948 8.95606 5.56412 8.7981 5.72182L6.0481 8.47182C5.89041 8.62978 5.79576 8.83985 5.78192 9.06262C5.76809 9.28539 5.836 9.50556 5.97293 9.68182L8.5396 12.9818C7.40377 14.7058 6.60443 16.6292 6.18377 18.6505L2.05693 19.1657C1.83401 19.1935 1.62908 19.3022 1.48105 19.4712C1.33302 19.6402 1.2522 19.8577 1.25393 20.0823V23.9433C1.2522 24.168 1.33302 24.3854 1.48105 24.5544C1.62908 24.7234 1.83401 24.8321 2.05693 24.86L6.18377 25.3752C6.60443 27.3964 7.40377 29.3198 8.5396 31.0438L5.9821 34.3438C5.84517 34.5201 5.77725 34.7402 5.79109 34.963C5.80493 35.1858 5.89957 35.3959 6.05727 35.5538L8.80727 38.3038C8.96523 38.4615 9.1753 38.5562 9.39807 38.57C9.62084 38.5838 9.841 38.5159 10.0173 38.379L13.3173 35.8215C15.0416 36.9571 16.9648 37.757 18.9859 38.1792L19.5011 42.3042C19.5289 42.5271 19.6377 42.732 19.8067 42.88C19.9757 43.0281 20.1931 43.1089 20.4178 43.1072H24.3008C24.5254 43.1089 24.7429 43.0281 24.9119 42.88C25.0808 42.732 25.1896 42.5271 25.2174 42.3042L25.7326 38.1792C27.7537 37.757 29.6769 36.9571 31.4013 35.8215L34.6921 38.379C34.8684 38.5159 35.0885 38.5838 35.3113 38.57C35.5341 38.5562 35.7441 38.4615 35.9021 38.3038L38.6521 35.5538C38.8098 35.3959 38.9044 35.1858 38.9183 34.963C38.9321 34.7402 38.8642 34.5201 38.7273 34.3438L36.1698 31.0438C37.3056 29.3198 38.1049 27.3964 38.5256 25.3752L42.6139 24.8527Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3346 33.9185C28.916 33.9185 34.2513 28.5832 34.2513 22.0018C34.2513 15.4204 28.916 10.0851 22.3346 10.0851C15.7532 10.0851 10.418 15.4204 10.418 22.0018C10.418 28.5832 15.7532 33.9185 22.3346 33.9185Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.334 10.0851V19.2518",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.334 24.7518C23.8528 24.7518 25.084 23.5206 25.084 22.0018C25.084 20.483 23.8528 19.2518 22.334 19.2518C20.8152 19.2518 19.584 20.483 19.584 22.0018C19.584 23.5206 20.8152 24.7518 22.334 24.7518Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.498 23.7014L31.7049 29.3645",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1697 23.7014L12.9629 29.3645",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_5874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertKeySkill);
export default __webpack_public_path__ + "static/media/expert_key_skill.cc71d6018ede99e36354b8c116273772.svg";
export { ForwardRef as ReactComponent };